<template>
  <section>
    <div class="left">
      <detail-entity-info :entity="entity" v-if="entity.id">
      </detail-entity-info>
      <h2 v-else v-translate>Základní údaje</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <select-box
            id="brand"
            :required="true"
            :disabled="!editable || isUpdate"
            :options="brandOptions"
            v-model="entity.id_brand"
            ref="brandref"
        >
          <translate class="translate">Brand</translate>
        </select-box>
      </div>
      <div class="field_right">
        <select-box
            id="device_type"
            :required="true"
            :disabled="!editable || isUpdate"
            :options="deviceTypeOptions"
            v-model="entity.id_device_type"
            ref="devicetyperef"
        >
          <translate class="translate">Typ zařízení</translate>
        </select-box>
      </div>
      <div class="field_left">
          <text-input
              id="version"
              :required="true"
              v-model="entity.version"
              ref="versionref"
              :disabled="!editable"
          ><translate class="translate">Verze</translate></text-input>
      </div>
      <div class="field_right">
        <text-input
            id="url"
            :required="true"
            v-model="entity.url"
            ref="urlref"
            :disabled="!editable"
            :help-text="$gettext('Může obsahovat zástupné znaky {domain} a {protocol}')"
        ><translate class="translate">Přesměrovávané URL</translate></text-input>
      </div>
    </div>
  </section>
</template>

<script>
import DetailEntityInfo from "../../../common/DetailEntityInfo";

export default {
  name: "BasicInfo",
  components: {
    DetailEntityInfo
  },
  props: {
    entity: Object,
    editable: Boolean,
    isUpdate: Boolean,
  },
  data() {
    return {
      brandOptions: [],
      deviceTypeOptions: [],
    }
  },
  created(BrandService, DeviceTypeService) {
    this.brandService = BrandService;
    this.deviceTypeService = DeviceTypeService;

    this.brandService.getEntitiesForSelectBox()
        .then(data => {
          this.brandOptions = this._.map(data.brands, function (item) {
            return {id: item['id'], text: item['name']}
          });
        });

    this.deviceTypeService.getEntitiesForSelectBox()
        .then(data => {
          this.deviceTypeOptions = this._.map(data.device_types, function (item) {
            return {id: item['id'], text: item['name']}
          });
        });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/versionRedirect/forms/BasicInfo.vue